import type { RouteEntry } from '../types';

// ═══════════════════════════════════════════════════════════════════════════
// REINSURANCE
// ═══════════════════════════════════════════════════════════════════════════
export const REINSURANCE_ROUTES: RouteEntry[] = [
  {
    path: 'reinsurance-module',
    component: 'ReinsuranceDashboard',
    label: 'Dashboard',
    allowedRoles: [], // no ProtectedRoute wrapper — function dashboard
    functionality: 'reinsurance',
    navSection: 'Overview',
    navIcon: 'Dashboard',
    // MISMATCH: route has no role guard
  },
  {
    path: 'ri-treaties',
    component: 'TreatyManagementPage',
    label: 'Treaty Management',
    allowedRoles: ['super_admin', 'admin', 'consultant_user', 'company_user'],
    functionality: 'reinsurance',
    navSection: 'Reinsurance',
    navIcon: 'CompareArrows',
    // MISMATCH: nav has no roles (all) but route restricts to 4 roles
  },
  {
    path: 'ri-performance',
    component: 'PerformanceDashboardPage',
    label: 'Performance',
    allowedRoles: ['super_admin', 'admin', 'consultant_user', 'company_user'],
    functionality: 'reinsurance',
    navSection: 'Reinsurance',
    navIcon: 'ShowChart',
    // MISMATCH: nav has no roles (all) but route restricts to 4 roles
  },
  {
    path: 'ri-adequacy',
    component: 'AdequacyReportPage',
    label: 'Adequacy Report',
    allowedRoles: ['super_admin', 'admin', 'consultant_user'],
    functionality: 'reinsurance',
    navSection: 'Reinsurance',
    navIcon: 'FactCheck',
    navRoles: ['super_admin', 'admin', 'consultant_user'],
  },
];
